import { invariant } from '@e-socna/utils';

import { FolderContextStatus } from '../types/folder-context.type';

import { useFolderContext } from './useFolderContext.hook';

export const useFolderReadyContext = () => {
  const context = useFolderContext();

  invariant(
    context.status === FolderContextStatus.Ready,
    'useFolderReadyContext requires FolderContext to be ready',
  );

  return context;
};
